import React, { useContext } from 'react';
import { Settings } from '@atlaskit/atlassian-navigation';
import Popup from '@atlaskit/popup';
import { ButtonItem, MenuGroup, Section } from '@atlaskit/menu';
import { css } from '@emotion/core';

import { useOpenableController, Theme, ThemeContext } from '@/controllers';
import { formatDateForDisplay } from '@/utils';
import { FCC } from '@/utils/types';

const nonInteractiveStyles = css({
  padding: '8px 20px',
});

const NonInteractiveItem: FCC = ({ children }) => (
  <span css={nonInteractiveStyles}>{children}</span>
);

const NavSettings: React.FC = () => {
  const openableController = useOpenableController();
  const [theme, setTheme] = useContext(ThemeContext);

  return (
    <Popup
      onClose={openableController.onClose}
      placement="bottom-start"
      isOpen={openableController.isOpen}
      trigger={props => (
        <Settings
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          isSelected={openableController.isOpen}
          tooltip=""
          onClick={openableController.onToggle}
        />
      )}
      content={() => (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <MenuGroup>
          <Section title="Service">
            <NonInteractiveItem>Tome</NonInteractiveItem>
          </Section>
          <Section title="Version">
            <NonInteractiveItem>{process.env.npm_package_version}</NonInteractiveItem>
          </Section>
          <Section title="Deployed">
            <NonInteractiveItem>{formatDateForDisplay(__BUILD_DATE__)}</NonInteractiveItem>
          </Section>
          {__TOKENS_ENABLED__ && (
            <Section title="Theme">
              <ButtonItem onClick={() => setTheme(Theme.Light)} isSelected={theme === Theme.Light}>
                Atlassian Light
              </ButtonItem>
              <ButtonItem onClick={() => setTheme(Theme.Dark)} isSelected={theme === Theme.Dark}>
                Atlassian Dark
              </ButtonItem>
            </Section>
          )}
        </MenuGroup>
      )}
    />
  );
};

export default NavSettings;
